/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { type RefObject, useEffect, useEffectEvent } from 'react';

/**
 * Calls `onOutside` when a pointer goes down outside every given element. Listens in the capture
 * phase: desktop windows, the dock and widgets stop click propagation, which hides clicks on them
 * from `ClickAwayListener`.
 */
export function useOutsidePointerDown(
  isActive: boolean,
  refs: ReadonlyArray<RefObject<HTMLElement | null>>,
  onOutside: () => void,
) {
  const handlePointerDown = useEffectEvent((event: PointerEvent) => {
    const { target } = event;
    if (target instanceof Node && refs.some((ref) => ref.current?.contains(target))) return;
    onOutside();
  });

  useEffect(() => {
    if (!isActive) return;
    document.addEventListener('pointerdown', handlePointerDown, true);
    return () => document.removeEventListener('pointerdown', handlePointerDown, true);
  }, [isActive]);
}
